// import { TableInstance } from 'react-table';

import GlobalFilterTextField from "../GlobalFilterTextField";
import ToggleFilterButton from "../ToggleFilterButton";

import { cn } from "../../../helpers/cn";

/*
interface TableTopToolbarProps<T extends object> {
  instance: TableInstance<T>;
  renderTopToolbar?: (tableInstance: TableInstance<T>) => JSX.Element;
  openColumnFilter?: boolean;
  handleColumnFilterToggle?: () => void;
}
*/

function TableTopToolbar({
  instance,
  openColumnFilter,
  handleColumnFilterToggle,
  renderTopToolbar,
  classNameTopToolbar,
  renderWithTopToolbar,
  disabledTopToolbar,
}) {
  const {
    setGlobalFilter,

    state: { globalFilter },
  } = instance;

  if (disabledTopToolbar) {
    return null;
  }

  return renderTopToolbar ? (
    renderTopToolbar(instance, openColumnFilter, handleColumnFilterToggle)
  ) : (
    <div
      className={cn(
        "tw-flex-wrap tw-mb-2 tw-flex tw-gap-2 md:tw-gap-x-2",
        classNameTopToolbar
      )}
    >
      <GlobalFilterTextField
        globalFilter={globalFilter}
        setGlobalFilter={setGlobalFilter}
      />

      <ToggleFilterButton
        openColumnFilter={openColumnFilter}
        handleColumnFilterToggle={handleColumnFilterToggle}
      />

      {renderWithTopToolbar &&
        renderWithTopToolbar(
          instance,
          openColumnFilter,
          handleColumnFilterToggle
        )}
    </div>
  );
}

export default TableTopToolbar;
